import { GET_FILE } from '../actions/types';
import { PostDispatch } from '../types';

const FileReducer = (state = null, action: PostDispatch) => {
    switch (action.type) {
        case GET_FILE:
            return action.payload;
        default:
            return state;
    }
};

export default FileReducer;
